import { render } from "./MiniWizardStickyBacker.vue?vue&type=template&id=53027b1b"
import script from "./MiniWizardStickyBacker.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyBacker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__